import {
  compose,
} from 'recompose';

import OfflineUnsupported from './offlineUnsupported';

const enhancer = compose();

export default enhancer(OfflineUnsupported);
